<template>
    <div style="margin-left: 30px;">
        <!-- <div v-for="i in 100" :key="i" :class="'menu-item '+(i===menuIndex?'menu-active':'')" @click="selMenu(i)">
          <div>
            <i class="el-icon-star-on"></i>
          </div>
          <div style="margin-left: 20px;">
            精选{{i}}
          </div>
        </div> -->
        <div v-for="(item,index) in menus" :key="index" :class="'menu-item '+(index===menuIndex?'menu-active':'')" @click="selMenu(index)">
          <div>
            <i class="el-icon-star-on"></i>
          </div>
          <div style="margin-left: 20px;">
            {{item}}
          </div>
        </div>
    </div>
</template>

<script>
    export default {
      name: "index",
      data() {
        return {
          menuIndex: 0,
          menus:['首页','电影','电视剧','短视频','资讯']
        };
      },
      mounted() {
      },
      methods: {
        selMenu(index){
          this.menuIndex = index;
          console.log(index);
          switch (index) {
            case 0:
              this.$router.push({path: '/index'});
              break;
            case 1:
              this.$router.push({path: '/dianying'});
              break;
            case 2:
              this.$router.push({path: '/dianshiju'});
              break;
            case 3:
            case 4:
              this.$router.push({path: '/list'});
              break;
            default:
              this.$router.push({path: '/index'});
          }
        }
      }
    }
</script>

<style scoped>
.menu-item{
  display: flex;
  height: 50px;
  font-size: 16px;
  color: #bcbcbc;
  line-height: 50px;
  padding: 0 10px;
  cursor: pointer;
}
  .menu-active{
    color: #00d1d1!important;
  }
  .menu-item:hover{
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/page/menu/index.vue